module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0017.jpg?v=8f88d7ec";